// @flow

import { type InstalmentsPlan } from '../../types';
import { type Amount } from '@tectonics/prs/money';

export function getAmountPartialFirst(instalmentsPlan: InstalmentsPlan): Amount {
  return instalmentsPlan['amount_partial_first'];
}
